import clsx from 'clsx';
import { type ToolsResourcesSection } from '../../../../services/globalNavItems/types';
import { SegmentAwareAnchor } from '../../../SegmentLink';
import { Typography } from '../../../Typography';

type ToolsResourcesSectionProps = {
  section: ToolsResourcesSection;
  l1Title: string;
  l2Title: string;
};

export function ToolsResourcesSection({ section, l1Title, l2Title }: ToolsResourcesSectionProps) {
  if (!section.toolsResourcesLinks.length) {
    return null;
  }

  return (
    <div
      className={clsx(
        'flex',
        'flex-col',
        'bg-[#effcf8]',
        'rounded-[6px]',
        'p-4',
        'w-[270px]',
        'mb-7',
        'mt-[-5px]',
        'h-fit',
      )}
    >
      <Typography variant="accent-small" className={clsx('text-neutral-darker', '!font-bold')}>
        {section.label}
      </Typography>
      <ul className={clsx('flex', 'flex-col', 'gap-4', 'p-0', 'm-0', 'mt-4')}>
        {section.toolsResourcesLinks.map((link, index) => (
          <li key={link.title} className={clsx('flex', 'list-none')}>
            <SegmentAwareAnchor
              segmentAttributes={{
                destination_url: link.itemLink.uri,
                entity_name: 'global_nav_l2_supplemental_link',
                item_copy: link.title,
                item_level: 2,
                item_position: index,
                l1_nav_copy: l1Title,
                l2_nav_copy: l2Title,
                navigation_format: 'header',
              }}
              href={link.itemLink.uri}
              className={clsx(
                'text-xsmall',
                'text-blue-default',
                'font-medium',
                'no-underline',
                'cursor-pointer',
                'hover:underline',
              )}
              aria-label={`Navigate to ${link.title}`}
            >
              {link.title}
            </SegmentAwareAnchor>
          </li>
        ))}
      </ul>
    </div>
  );
}
